/* eslint-disable no-magic-numbers */
/* eslint-disable @typescript-eslint/member-delimiter-style */
import { VAT_ITALY_PATTERN } from '~shared/validators/pattern-validators';

export interface VatLogDataInterface {
  vatNumber: string;
  reason: string[];
}

export class VatNumberAnonymizerService {
  static prefixes = ['IT', 'PT'];
  static spcRegex = /\s/g;
  static numRegex = /[a-zA-Z0-9]/g;
  static _vatNumber: string;
  static _maskedVat: string;

  static mask(): void {
    this.maskedVat = this._vatNumber.replace(this.numRegex, '*');
  }

  static get vatNumber(): string {
    return this._vatNumber;
  }

  static set vatNumber(vatNumber: string) {
    this._vatNumber = vatNumber;
  }

  static get maskedVat(): string {
    return this._maskedVat;
  }

  static set maskedVat(vatNumber: string) {
    this._maskedVat = vatNumber;
  }

  static shapeLogData(): VatLogDataInterface {
    this.mask();

    return {
      vatNumber: this.maskedVat,
      reason: this.getReason(),
    };
  }

  static getReason(): string[] {
    const reason = [];

    const prefix = this.vatNumber.substring(0, 2); // NOSONAR

    if (!this.prefixes.includes(prefix)) {
      reason.push('does not start with market prefix');
    }

    if (this.spcRegex.test(this.vatNumber)) {
      reason.push('contains space');
    }

    if (!VAT_ITALY_PATTERN.test(this.vatNumber)) {
      reason.push('invalid characters');
    }

    return reason;
  }
}
